'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OfferExpiryCountdown = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _CountdownTimer = require('components/CountdownTimer/CountdownTimer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OfferExpiryCountdown = exports.OfferExpiryCountdown = function (_PureComponent) {
  (0, _inherits3.default)(OfferExpiryCountdown, _PureComponent);

  function OfferExpiryCountdown() {
    (0, _classCallCheck3.default)(this, OfferExpiryCountdown);
    return (0, _possibleConstructorReturn3.default)(this, (OfferExpiryCountdown.__proto__ || (0, _getPrototypeOf2.default)(OfferExpiryCountdown)).apply(this, arguments));
  }

  (0, _createClass3.default)(OfferExpiryCountdown, [{
    key: 'render',
    value: function render() {
      var countdownTo = this.props.countdownTo;


      return _react2.default.createElement(
        'p',
        { className: 'text--bold' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'inviteafriend.offer-expires-in',
          defaultMessage: 'Offer expires in'
        }),
        '\xA0',
        _react2.default.createElement(_CountdownTimer.CountdownTimer, { countdownTo: countdownTo })
      );
    }
  }]);
  return OfferExpiryCountdown;
}(_react.PureComponent);

OfferExpiryCountdown.propTypes = {
  countdownTo: _propTypes2.default.number.isRequired
};